define("calendar/components/calendar/onboarding/wizards/begin-onboarding", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking, _emberConcurrency, _emberConcurrencyTs) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _trackAttemptedMediaUpload;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Wizard @cacheKey="beginOnboarding-wizard" @inline={{true}} @primaryClass="tOB--modalBg" as |wizard|>
    <wizard.slide @primaryClass="tOB--modalCard o--modalCard" @skip={{@didUploadMedia}} as |slide|>
      <slide.body>
        <div class="tOB--wizard">
          <div class="tOB--wizard__left">
            <figure class="o--mediaContainer">
              <img
                alt={{t "shared_phrases.upload_media"}}
                class="o--media"
                src="/assets/images/img--ob__uploadMedia.png"
              />
              <b class="o--mediaOverlay"></b>
            </figure>
          </div>
          <div class="tOB--wizard__right">
            <div class="tOB--wizard__contentWrapper">
              <h2 class="tOB--wizard__title">
                {{t "onboarding.upload.title_new_icons"}}
              </h2>
              <p class="tOB--wizard__subtitle">
                {{html-safe (t "onboarding.upload.desc_new_icons")}}
              </p>
              <ul class="tOB--wizard__ul--sm has--listStyleDisc">
                <li class="tOB--wizard__li">{{html-safe (t "onboarding.upload.tutorial_step_1_new_icons")}}</li>
                <li class="tOB--wizard__li">{{html-safe (t "onboarding.upload.tutorial_step_2_new_icons")}}</li>
              </ul>
              <p>{{html-safe (t "onboarding.upload.tutorial_test_image")}}</p>
            </div>
  
            <footer class="tOB--wizard__footer--inner" {{on "click" (set this "promptUploadMedia" true)}}>
              {{#if @didUploadMedia}}
                <p class="u--text--sm u--text--light">
                  {{t "onboarding.upload.media_added"}}
                </p>
                <slide.finishButton
                  @buttonClass="o--btn o--btn--block o--btn--primary"
                  @finishWizard={{@transition}}
                  @isLastSlide={{true}}
                  @onClick={{fn @trackOnboardingStep "uploaded-media-onboarding"}}
                  @text={{t "shared_words.continue"}}
                  data-test-id="continue-button"
                />
              {{else}}
                <slide.finishButton
                  @buttonClass="o--btn o--btn--block o--btn--default"
                  @finishWizard={{this.browse}}
                  @isLastSlide={{true}}
                  @onClick={{this.trackUploadMediaEvents}}
                  data-test-id="upload-button"
                >
                  {{svg-jar "upload" class="o--icon o--icon--hl u--m__r__xs"}}
                  {{t "shared_phrases.upload_media"}}
                </slide.finishButton>
                {{#unless this.socialProfileIsTiktok}}
                  <slide.finishButton
                    @buttonClass="o--btn o--btn--block o--btn--default at--testImgTour__tryTestImg"
                    @finishWizard={{@transition}}
                    @isLastSlide={{true}}
                    @onClick={{perform this.addTestImage}}
                  >
                    {{svg-jar "media-add" class="o--icon o--icon--hl u--m__r__xs"}}
                    <span class="u--text--capitalize">{{t "onboarding.upload.try_test_image"}}</span>
                  </slide.finishButton>
                {{/unless}}
              {{/if}}
            </footer>
          </div>
        </div>
      </slide.body>
    </wizard.slide>
  </Shared::Wizard>
  <input accept="image/*,video/*,video/mp4,video/x-m4v" class="u--hide" id="input" multiple type="file" />
  */
  {
    "id": "Y6/Qmymq",
    "block": "[[[8,[39,0],null,[[\"@cacheKey\",\"@inline\",\"@primaryClass\"],[\"beginOnboarding-wizard\",true,\"tOB--modalBg\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"slide\"]],null,[[\"@primaryClass\",\"@skip\"],[\"tOB--modalCard o--modalCard\",[30,2]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n          \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n            \"],[10,\"img\"],[15,\"alt\",[28,[37,1],[\"shared_phrases.upload_media\"],null]],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--ob__uploadMedia.png\"],[12],[13],[1,\"\\n            \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tOB--wizard__contentWrapper\"],[12],[1,\"\\n            \"],[10,\"h2\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"onboarding.upload.title_new_icons\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"tOB--wizard__subtitle\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[[28,[37,1],[\"onboarding.upload.desc_new_icons\"],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul--sm has--listStyleDisc\"],[12],[1,\"\\n              \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,[28,[35,2],[[28,[37,1],[\"onboarding.upload.tutorial_step_1_new_icons\"],null]],null]],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,[28,[35,2],[[28,[37,1],[\"onboarding.upload.tutorial_step_2_new_icons\"],null]],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,2],[[28,[37,1],[\"onboarding.upload.tutorial_test_image\"],null]],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[11,\"footer\"],[24,0,\"tOB--wizard__footer--inner\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0],\"promptUploadMedia\",true],null]],null],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"              \"],[10,2],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"onboarding.upload.media_added\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[8,[30,3,[\"finishButton\"]],[[24,\"data-test-id\",\"continue-button\"]],[[\"@buttonClass\",\"@finishWizard\",\"@isLastSlide\",\"@onClick\",\"@text\"],[\"o--btn o--btn--block o--btn--primary\",[30,4],true,[28,[37,6],[[30,5],\"uploaded-media-onboarding\"],null],[28,[37,1],[\"shared_words.continue\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[30,3,[\"finishButton\"]],[[24,\"data-test-id\",\"upload-button\"]],[[\"@buttonClass\",\"@finishWizard\",\"@isLastSlide\",\"@onClick\"],[\"o--btn o--btn--block o--btn--default\",[30,0,[\"browse\"]],true,[30,0,[\"trackUploadMediaEvents\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,7],[\"upload\"],[[\"class\"],[\"o--icon o--icon--hl u--m__r__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,1],[\"shared_phrases.upload_media\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"],[41,[51,[30,0,[\"socialProfileIsTiktok\"]]],[[[1,\"                \"],[8,[30,3,[\"finishButton\"]],null,[[\"@buttonClass\",\"@finishWizard\",\"@isLastSlide\",\"@onClick\"],[\"o--btn o--btn--block o--btn--default at--testImgTour__tryTestImg\",[30,4],true,[28,[37,9],[[30,0,[\"addTestImage\"]]],null]]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,7],[\"media-add\"],[[\"class\"],[\"o--icon o--icon--hl u--m__r__xs\"]]]],[1,\"\\n                  \"],[10,1],[14,0,\"u--text--capitalize\"],[12],[1,[28,[35,1],[\"onboarding.upload.try_test_image\"],null]],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"],[10,\"input\"],[14,\"accept\",\"image/*,video/*,video/mp4,video/x-m4v\"],[14,0,\"u--hide\"],[14,1,\"input\"],[14,\"multiple\",\"\"],[14,4,\"file\"],[12],[13]],[\"wizard\",\"@didUploadMedia\",\"slide\",\"@transition\",\"@trackOnboardingStep\"],false,[\"shared/wizard\",\"t\",\"html-safe\",\"on\",\"set\",\"if\",\"fn\",\"svg-jar\",\"unless\",\"perform\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/begin-onboarding.hbs",
    "isStrictMode": false
  });

  let BeginOnboardingComponent = (_class = (_trackAttemptedMediaUpload = /*#__PURE__*/new WeakSet(), class BeginOnboardingComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _trackAttemptedMediaUpload);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "onboarding", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _initializerDefineProperty(this, "promptUploadMedia", _descriptor4, this);

      if (this.args.didUploadMedia) {
        this.args.transition();
      }
    }

    get socialProfileIsTiktok() {
      return this.auth.currentSocialProfile.isTiktok;
    }

    browse() {
      _classPrivateMethodGet(this, _trackAttemptedMediaUpload, _trackAttemptedMediaUpload2).call(this);

      const btn = document.querySelector(`input[type=file]`);

      if (btn) {
        btn.click();
      }
    }

    *addTestImage() {
      yield (0, _emberConcurrencyTs.taskFor)(this.onboarding.addTestImage).perform();
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "promptUploadMedia", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "browse", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "browse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addTestImage", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "addTestImage"), _class.prototype)), _class);
  _exports.default = BeginOnboardingComponent;

  function _trackAttemptedMediaUpload2() {
    this.segment.track('attempted-uploading-media', {
      area: 'onboarding_modal',
      button: 'upload'
    });
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BeginOnboardingComponent);
});